import { Button } from "./ui/button";
import { useLanguage } from "../contexts/LanguageContext";
import { toast } from "sonner";
import { Globe, Check } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

export const LanguageSwitcher = () => {
    const { language, setLanguage, t } = useLanguage();

    const handleLanguageChange = (newLang: "ar" | "en") => {
        if (newLang !== language) {
            setLanguage(newLang);
            localStorage.setItem("language", newLang);
            toast.success(t("settings.language.success") || "Language updated successfully");
            // Optional: reload to ensure all components react correctly if context isn't enough
            // window.location.reload(); 
        }
    };

    return (
        <Card id="language-settings">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <Globe className="w-5 h-5" />
                    {t("settings.language.title")}
                </CardTitle>
                <CardDescription>
                    {t("settings.language.subtitle")}
                </CardDescription>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Button
                        variant={language === "ar" ? "default" : "outline"}
                        className="h-20 flex flex-col items-center justify-center gap-2 text-lg"
                        onClick={() => handleLanguageChange("ar")}
                    >
                        <div className="flex items-center gap-2">
                            <span>العربية</span>
                            {language === "ar" && <Check className="w-5 h-5" />}
                        </div>
                        <span className="text-xs opacity-70 font-normal">Arabic</span>
                    </Button>
                    <Button
                        variant={language === "en" ? "default" : "outline"}
                        className="h-20 flex flex-col items-center justify-center gap-2 text-lg"
                        onClick={() => handleLanguageChange("en")}
                    >
                        <div className="flex items-center gap-2">
                            <span>English</span>
                            {language === "en" && <Check className="w-5 h-5" />}
                        </div>
                        <span className="text-xs opacity-70 font-normal">الإنجليزية</span>
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};